export default __webpack_public_path__ + "static/media/c_mobile_dr_01.40d732d2.png";